import React from 'react';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ImageHeader from '../../components/ImageHeader';

import ProjectItem from './ProjectItem';
import { Container, ProjectContainer, ProjectsList } from './styles';

const Portfolio: React.FC = () => {
  return (
    <>
      <Header />

      <ImageHeader title="PORTFÓLIO" goToDiv="portfolio" />

      <Container id="portfolio">
        <ProjectContainer>
          <ProjectsList>
            <ProjectItem firstHeader="PROJETO" secondHeader="01" />
            <ProjectItem firstHeader="PROJETO" secondHeader="02" />
            <ProjectItem firstHeader="PROJETO" secondHeader="03" />
            <ProjectItem firstHeader="PROJETO" secondHeader="04" />
            <ProjectItem firstHeader="PROJETO" secondHeader="05" />
            <ProjectItem firstHeader="PROJETO" secondHeader="06" />
            <ProjectItem firstHeader="PROJETO" secondHeader="07" />
            <ProjectItem firstHeader="PROJETO" secondHeader="08" />
            <ProjectItem firstHeader="PROJETO" secondHeader="09" />
            <ProjectItem firstHeader="PROJETO" secondHeader="10" />
            <ProjectItem firstHeader="PROJETO" secondHeader="11" />
            <ProjectItem firstHeader="PROJETO" secondHeader="12" />
          </ProjectsList>
        </ProjectContainer>
      </Container>

      <Footer />
    </>
  );
};

export default Portfolio;
